(function($){

	$(document).ready(function(){

		$(document).on('click','.external-link',function(e){
			
			if($(this).attr('href').includes('icg-enterprise.co.uk') || $(this).attr('href').includes('icgtrust.local') || $(this).attr('href').includes('wpengine.com')) { 
				return true; 
			}

			e.preventDefault();
			$target_link = $(this).attr('href');

			const externallinkModal = document.getElementById('externallinkModal');

			if(externallinkModal) {
				externallinkModal.querySelector('.btn').href = $target_link;

				var $external_link_modal = new bootstrap.Modal('#externallinkModal', { 'backdrop': true });

				$external_link_modal.show();
			}
		});

		$(document).on('click','.external-link-btn',function(e){
			const externallinkModal = document.getElementById('externallinkModal');

			if(externallinkModal) {
				var $external_link_modal = bootstrap.Modal.getInstance(externallinkModal);
				$external_link_modal.hide();
			}
		});

	});
	
})(jQuery);